import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Admin.css";
import { apiFetch } from "../utils/api";

export default function Admin() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("adminToken");
    if (!token) {
      navigate("/bhavdeep");
      return;
    }

    apiFetch("/api/orders", {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => {
        if (!r.ok) throw new Error("Unauthorized");
        return r.json();
      })
      .then((data) => setOrders(data))
      .catch(() => {
        localStorage.removeItem("adminToken");
        navigate("/bhavdeep");
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    navigate("/bhavdeep");
  };

  if (loading) return <p className="loading">Loading...</p>;

  return (
    <div className="admin">
      <div className="admin-header">
        <h1>Admin Dashboard</h1>
        <button onClick={handleLogout} className="logout-btn">
          Logout
        </button>
      </div>

      {orders.length === 0 ? (
        <p className="no-orders">No orders yet</p>
      ) : (
        <div className="admin-table-wrapper">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Customer Name</th>
                <th>Phone</th>
                <th>Address</th>
                <th>Wig Product</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o._id}>
                  <td>{new Date(o.createdAt).toLocaleDateString()}</td>
                  <td>{o.customerName}</td>
                  <td>{o.phone}</td>
                  <td>{o.address.substring(0, 40)}...</td>
                  <td>{o.wig?.name || "N/A"}</td>
                  <td>₹{o.wig?.price.toLocaleString() || "N/A"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
